<template>
  <div class="api-key-expiration-table-cell">
    <div class='api-key-expiration-table-cell__date' :class='keyStatus'>
      <div class='api-key-expiration-table-cell__date__container' >
        {{ formattedDate }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'APIKeyExpirationTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return this.item[this.column.field];
    },
    keyStatus() {
      const difference = new Date(this.formattedDate).getTime() - new Date().getTime();
      const totalDays = Math.ceil(difference / (1000 * 3600 * 24));
      if (totalDays <= 0) {
        return 'exp-alert';
      }
      if (totalDays <= 10) {
        return 'exp-warning';
      }
      return 'exp-good';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.api-key-expiration-table-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: $font-family-regular;
  &__date {
    justify-content: center;
    height: rem(30);
    border-radius: $radius-md;
    width: fit-content;
    text-align: left;
    padding: 0 $space-2;
    display: flex;
    &.exp-alert {
      color: var(--severity-critical);
      background-color: var(--severity-critical-bg);
    }
    &.exp-warning {
      color: var(--severity-medium);
      background-color: var(--severity-medium-bg);
    }
    &.exp-good {
      color: var(--severity-low);
      background-color: var(--severity-low-bg);
    }
    &__container{
      margin-top: rem(-13);
    }
  }
}
</style>
